<script>
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';
import { mapActions, mapGetters } from 'vuex';

import VSelect from '@/components/Common/VSelect';
import VInput from '@/components/Common/VInput';
import Loader from '@/components/Common/Loader';
import wordEnding from '@/utils/wordEnding';
import priceFormat from '@/utils/priceFormat';

const initFormData = () => ({
  brand: null,
  model: null,
  year: null,
  generation: null,
  body: null,
  doors: null,
  gear: null,
  drive: null,
  engine: null,
  power: null,
  volume: null,
  mileage: null,
  region: null,
  files: [],
  name: null,
  phone: null,
});

export default {
  name: 'popupCalculator',
  components: {
    VSelect,
    VInput,
    Loader,
    VeeForm: Form,
    VeeField: Field,
  },
  initFormData,
  data() {
    return {
      formValues: this.$options.initFormData(),
      calcedPrice: null,
      calcedPriceError: null,
      showResult: false,
      fileDescription: 'Загрузите файлы',
    };
  },
  setup() {
    const schema = Yup.object().shape({
      brand: Yup.mixed().nullable(false).required(),
      model: Yup.mixed().nullable(false).required(),
      year: Yup.mixed().nullable(false).required(),
      generation: Yup.mixed().nullable(false).required(),
      body: Yup.mixed().nullable(false).required(),
      gear: Yup.mixed().nullable(false).required(),
      drive: Yup.mixed().nullable(false).required(),
      engine: Yup.mixed().nullable(false).required(),
      power: Yup.mixed().nullable(false).required(),
      region: Yup.mixed().nullable(false).required(),
      name: Yup.string().required(),
      phone: Yup.string().required(),
    });

    return {
      schema,
    };
  },
  watch: {
    bodies() {
      if (this.bodies.length === 1) {
        this.formValues.body = this.bodies[0];
      }
    },
    gears() {
      if (this.gears.length === 1) {
        this.formValues.gear = this.gears[0];
      }
    },
    drives() {
      if (this.drives.length === 1) {
        this.formValues.drive = this.drives[0];
      }
    },
    engines() {
      if (this.engines.length === 1) {
        this.formValues.engine = this.engines[0];
      }
    },
    'formValues.brand'() {
      if (
        this.formValues.brand &&
        this.popupData?.brand.id !== this.formValues.brand.id
      ) {
        this.loadModels({ brand: this.formValues.brand?.id });

        this.formValues.model = null;
        this.formValues.year = null;
        this.formValues.generation = null;
        this.formValues.body = null;
        this.formValues.gear = null;
        this.formValues.drive = null;
        this.formValues.engine = null;
        this.formValues.power = null;
      } else {
        this.addPopupData();
      }
    },
    'formValues.model'() {
      if (
        this.formValues.model &&
        this.popupData?.model.id !== this.formValues.model.id
      ) {
        this.loadYears({
          brand: this.formValues.brand?.id,
          model: this.formValues.model?.id,
        });

        this.formValues.year = null;
        this.generation = null;
        this.formValues.body = null;
        this.formValues.gear = null;
        this.formValues.drive = null;
        this.formValues.engine = null;
        this.formValues.power = null;
      }
    },
    'formValues.year'() {
      if (
        this.formValues.year &&
        this.popupData?.year.id !== this.formValues.year.id
      ) {
        this.loadGenerations({
          brand: this.formValues.brand?.id,
          model: this.formValues.model?.id,
          year: this.formValues.year?.id,
        });

        this.formValues.generation = null;
        this.formValues.body = null;
        this.formValues.gear = null;
        this.formValues.drive = null;
        this.formValues.engine = null;
        this.formValues.power = null;
      }
    },
    'formValues.generation'() {
      if (
        this.formValues.generation &&
        this.popupData?.generation.id !== this.formValues.generation.id
      ) {
        this.loadBodies({
          brand: this.formValues.brand?.id,
          model: this.formValues.model?.id,
          year: this.formValues.year?.id,
          generation: this.formValues.generation?.id,
        });

        this.formValues.body = null;
        this.formValues.gear = null;
        this.formValues.drive = null;
        this.formValues.engine = null;
        this.formValues.power = null;
      }
    },
    'formValues.body'() {
      if (this.formValues.body) {
        this.formValues.doors = this.formValues.body.doors;

        this.loadGears({
          brand: this.formValues.brand?.id,
          model: this.formValues.model?.id,
          year: this.formValues.year?.id,
          generation: this.formValues.generation?.id,
          body: this.formValues.body?.id,
          doors: this.formValues.doors,
        });
        this.loadDrives({
          brand: this.formValues.brand?.id,
          model: this.formValues.model?.id,
          year: this.formValues.year?.id,
          generation: this.formValues.generation?.id,
          body: this.formValues.body?.id,
          doors: this.formValues.doors,
        });
        this.loadEngines({
          brand: this.formValues.brand?.id,
          model: this.formValues.model?.id,
          year: this.formValues.year?.id,
          generation: this.formValues.generation?.id,
          body: this.formValues.body?.id,
          doors: this.formValues.doors,
        });

        this.formValues.gear = null;
        this.formValues.drive = null;
        this.formValues.engine = null;
        this.formValues.power = null;
      }
    },
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
      popupData: 'Popups/popupData',
      fetching: 'Vikup/fetching',
      mailTo: 'Vikup/mailTo',
      brands: 'Vikup/brands',
      models: 'Vikup/models',
      years: 'Vikup/years',
      generations: 'Vikup/generations',
      bodies: 'Vikup/bodies',
      gears: 'Vikup/gears',
      drives: 'Vikup/drives',
      engines: 'Vikup/engines',
      modifications: 'Vikup/modifications',
      regions: 'Vikup/regions',
    }),

    isShowedPopup() {
      if (this.allShowedOverlays?.includes('calculator')) {
        if (this.popupData) {
          Object.assign(this.formValues, this.popupData);
        }
      }

      return this.allShowedOverlays?.includes('calculator');
    },
    previewSrc() {
      return this.formValues.files.length > 0
        ? URL.createObjectURL(this.formValues.files[0])
        : '/public/images/svg/car.svg';
    },
    modificationOptions() {
      let result = [];

      this.modifications.forEach((modification, idx) => {
        result.push({
          ...modification,
          id: idx,
          text: [
            modification.body.text,
            modification.doors > 0
              ? modification.doors +
                ' ' +
                wordEnding(modification.doors, ['дверь', 'двери', 'дверей'])
              : null,
            modification.gear.text,
            modification.drive ? `${modification.drive.text} привод` : null,
            modification.engine.text,
            `${modification.volume.toFixed(1)}л`,
            `${modification.power} л.с.`,
            modification.wheel ? `${modification.wheel.text} руль` : null,
          ]
            .filter(char => char)
            .join(', '),
        });
      });

      return result;
    },
    engineTypes() {
      let result = [];
      this.engines.forEach(engine => {
        let current = result.find(r => r.id === engine.id);
        if (!current) {
          result.push({
            id: engine.id,
            text: engine.text,
          });
        }
      });
      return result;
    },
    powerTypes() {
      let result = [];
      this.engines.forEach(engine => {
        let current = result.find(r => r.id === engine.id);
        if (current) {
          current.push({
            id: `${engine.volume}-${engine.power}`,
            text: `${engine.volume.toFixed(1)}л, ${engine.power} л.с.`,
            power: engine.power,
            volume: engine.volume,
          });
        } else {
          result.push({
            id: `${engine.volume}-${engine.power}`,
            text: `${engine.volume.toFixed(1)}л, ${engine.power} л.с.`,
            power: engine.power,
            volume: engine.volume,
          });
        }
      });

      if (result.length === 1) {
        this.formValues.power = result[0];
      }

      return result;
    },
    regionOptions() {
      return this.regions.map(region => ({
        id: region.regionId,
        text:
          region.typeFullName === 'Город'
            ? `г. ${region.name}`
            : `${region.name} ${region.typeFullName}`,
      }));
    },
    estimatedPrice() {
      return this.calcedPrice || '-';
    },
    mailtoHref() {
      let body = [
        {
          name: 'Имя',
          value: this.formValues.name,
        },
        {
          name: 'Телефон',
          value: this.formValues.phone,
        },
        {
          name: 'Марка',
          value: this.popupData?.brand?.text,
        },
        {
          name: 'Модель',
          value: this.popupData?.model?.text,
        },
        {
          name: 'Поколение',
          value: this.popupData?.generation?.text,
        },
        {
          name: 'Год',
          value: this.popupData?.year?.text,
        },
        {
          name: 'Кузов',
          value:
            this.formValues.body?.text +
            (this.formValues.doors
              ? ' ' +
                this.formValues.doors +
                ' ' +
                wordEnding(this.formValues.doors, ['дверь', 'двери', 'дверей'])
              : ''),
        },
        {
          name: 'КПП',
          value: this.formValues.gear?.text,
        },
        {
          name: 'Привод',
          value: this.formValues.drive?.text,
        },
        {
          name: 'Двигатель',
          value: [
            this.formValues.engine?.text,
            this.formValues.power
              ? `${this.formValues.power.volume.toFixed(1)}л`
              : null,
            this.formValues.power
              ? `${this.formValues.power.power} л.с.`
              : null,
          ]
            .filter(char => char)
            .join(', '),
        },
        {
          name: 'Пробег',
          value: this.formValues.mileage
            ? priceFormat(this.formValues.mileage)
            : null,
        },
        {
          name: 'Регион',
          value: this.formValues.region?.text,
        },
      ]
        .filter(char => char.value)
        .map(char => `${char.name}: ${char.value}`)
        .join('%0A');

      return `mailto:${this.mailTo}?subject=Заявка на выкуп автомобиля&body=${body}`;
    },
  },
  mounted() {
    this.loadRegions();
    this.loadMailTo();
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addPopupData: 'Popups/addPopupData',
      loadBrands: 'Vikup/loadBrands',
      loadModels: 'Vikup/loadModels',
      loadYears: 'Vikup/loadYears',
      loadGenerations: 'Vikup/loadGenerations',
      loadModifications: 'Vikup/loadModifications',
      loadBodies: 'Vikup/loadBodies',
      loadGears: 'Vikup/loadGears',
      loadDrives: 'Vikup/loadDrives',
      loadEngines: 'Vikup/loadEngines',
      loadRegions: 'Vikup/loadRegions',
      loadMailTo: 'Vikup/loadMailTo',
      sendForm: 'Vikup/sendForm',
      loadCalcedPrice: 'Vikup/loadCalcedPrice',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    closePopup() {
      this.togglePopup('calculator');
    },
    calcPrice() {
      this.loadCalcedPrice({
        vin: '',
        brand: this.formValues.brand.id,
        model: this.formValues.model.id,
        year: this.formValues.year.id,
        generation: this.formValues.generation.id,
        body: this.formValues.body.id,
        doors: this.formValues.doors,
        gear: this.formValues.gear.id,
        drive: this.formValues.drive.id,
        engine: this.formValues.engine.id,
        power: this.formValues.power.power,
        volume: this.formValues.power.volume,
        region: this.formValues.region.id,
        mileage: this.formValues.mileage,
        wheel: 1,
        name: this.formValues.name,
        phone: this.formValues.phone,
      })
        .then(data => {
          this.showResult = true;
          this.onSubmit();
          if (data.priceCategories) {
            this.calcedPrice = priceFormat(
              data.priceCategories.low.min.toFixed(0),
            );
            this.calcedPriceError = null;
          } else {
            this.calcedPrice = null;
            this.calcedPriceError =
              'Не удалось рассчитать стоимость, но наши сотрудники обязательно свяжутся с вами с результатами предварительной оценки';
          }
        })
        .catch(() => {
          this.showResult = true;
          this.calcedPrice = null;
          this.calcedPriceError =
            'Не удалось рассчитать стоимость, но наши сотрудники обязательно свяжутся с вами с результатами предварительной оценки';
        });
    },
    onSubmit(value, actions) {
      const formData = new FormData();

      for (const key in this.formValues) {
        if (key === 'files') {
          for (let i = 0; i < this.formValues.files.length; i++) {
            formData.append(`files[${i}]`, this.formValues.files[i]);
          }
        } else {
          formData.append(
            key,
            this.formValues[key]?.text || this.formValues[key],
          );
        }
      }

      this.sendForm(formData);
      // this.togglePopup('calculator');
      // this.togglePopup('popup-message');
      // this.addTitlePopup('test')
    },
    previewFiles(event) {
      this.formValues.files = event.target.files || [];
      if (event.target.files.length == 1) {
        this.fileDescription = event.target.files[0].name;
      } else if (event.target.files.length > 1) {
        this.fileDescription = 'Число файлов: ' + event.target.files.length;
      } else {
        this.fileDescription = 'Загрузите файлы';
      }
    },
  },
};
</script>
<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isShowedPopup }"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between mb-2.5 md:mb-5">
          <img
            src="/public/images/logo.svg"
            alt=""
            class="w-full max-w-[186px] h-[41px] pr-2"
          />
          <div class="popup-new__close" @click="closePopup"></div>
        </div>
        <vee-form
          :validation-schema="schema"
          novalidate
          v-slot="{ meta }"
          class="relative"
          @submit="calcPrice"
        >
          <p class="title-h2 mb-6 !text-2xl pr-2">
            Заполните информацию <span>об&nbsp;автомобиле</span>
          </p>
          <div class="mb-8">
            <div
              class="grid grid-cols sm:grid-cols-2 sm:grid-cols-3 gap-y-4 gap-x-4"
            >
              <vee-field v-slot="{ handleChange, errorMessage }" name="brand">
                <v-select
                  v-model="formValues.brand"
                  :options="brands"
                  label="text"
                  placeholder="Выберите марку"
                  inscription="Марка авто*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="model">
                <v-select
                  v-model="formValues.model"
                  :options="models"
                  label="text"
                  placeholder="Выберите модель"
                  inscription="Модель*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="year">
                <v-select
                  v-model="formValues.year"
                  :options="years"
                  label="text"
                  placeholder="Укажите год"
                  inscription="Год*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field
                v-slot="{ handleChange, errorMessage }"
                name="generation"
              >
                <v-select
                  v-model="formValues.generation"
                  :options="generations"
                  label="text"
                  placeholder="Выберите поколение"
                  inscription="Поколение*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="body">
                <v-select
                  v-model="formValues.body"
                  :options="bodies"
                  label="text"
                  placeholder="Выберите кузов"
                  inscription="Кузов*"
                  :disabled="popupData?.generation === null"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <v-input
                v-model="formValues.mileage"
                format="price"
                placeholder="Укажите пробег"
                inscription="Пробег"
                theme="white"
              />

              <vee-field v-slot="{ handleChange, errorMessage }" name="gear">
                <v-select
                  v-model="formValues.gear"
                  :options="gears"
                  label="text"
                  placeholder="Выберите КПП"
                  inscription="КПП*"
                  :disabled="formValues.body === null"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="drive">
                <v-select
                  v-model="formValues.drive"
                  :options="drives"
                  label="text"
                  placeholder="Выберите привод"
                  inscription="Привод*"
                  :disabled="formValues.body === null"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="engine">
                <v-select
                  v-model="formValues.engine"
                  :options="engineTypes"
                  label="text"
                  placeholder="Выберите двигатель"
                  inscription="Двигатель*"
                  :disabled="formValues.body === null"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="power">
                <v-select
                  v-model="formValues.power"
                  :options="powerTypes"
                  label="text"
                  placeholder="Выберите объем и мощность"
                  inscription="Объем и мощность*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>

              <vee-field v-slot="{ handleChange, errorMessage }" name="region">
                <v-select
                  v-model="formValues.region"
                  :options="regionOptions"
                  label="text"
                  placeholder="Выберите регион"
                  inscription="Регион*"
                  :error="errorMessage"
                  @update:modelValue="handleChange"
                />
              </vee-field>
              <div class="relative">
                <input
                  ref="fileInput"
                  type="file"
                  name="file"
                  id="file"
                  placeholder="Загрузите файлы"
                  class="hidden"
                  multiple
                  @change="previewFiles"
                />
                <label for="file">
                  <div
                    class="w-full p-[12px] text-gray-600 border border-color-gray rounded-brand whitespace-nowrap overflow-hidden overflow-ellipsis cursor-pointer"
                  >
                    {{ fileDescription }}
                  </div>
                </label>
                <div
                  class="absolute -top-3 left-2 text-sm text-gray-600 px-1 bg-white"
                >
                  Загрузить файлы
                </div>
              </div>
            </div>
            <p class="title-h2 mb-6 !text-2xl pr-2">Контактое лицо</p>
            <div class="mb-8">
              <div
                class="grid grid-cols sm:grid-cols-2 sm:grid-cols-3 gap-y-4 gap-x-4"
              >
                <vee-field v-slot="{ handleChange, errorMessage }" name="name">
                  <v-input
                    v-model="formValues.name"
                    placeholder="Ваше имя*"
                    inscription="Ваше имя*"
                    name="name"
                    :error="errorMessage"
                    @update:modelValue="handleChange"
                  />
                </vee-field>
                <vee-field v-slot="{ handleChange, errorMessage }" name="phone">
                  <v-input
                    v-model="formValues.phone"
                    inscription="Телефон*"
                    format="phone"
                    placeholder="+7 (___) ___-__-__"
                    :error="errorMessage"
                    @update:modelValue="handleChange"
                  />
                </vee-field>
              </div>
            </div>
            <p class="text-sm mt-2">
              Поля со звездочкой обязательны для заполнения.
            </p>
          </div>
          <div
            class="w-full flex justify-center"
            :class="{ 'mb-8': showResult }"
          >
            <button
              type="submit"
              :disabled="!meta.valid"
              class="button button_green button_big"
              :class="{ 'pointer-events-none opacity-50': !meta.valid }"
            >
              Получить оценку автомобиля
            </button>
          </div>
        </vee-form>

        <div v-show="showResult" class="grid grid-cols gap-y-3 gap-x-3 my-8">
          <div v-if="calcedPriceError" class="mb-4">
            <p class="text-xl text-red">
              {{ calcedPriceError }}
            </p>
          </div>
          <div v-else class="mb-4">
            <p class="text-xl text-green">
              Оценка вашего автомобиля
              <span class="text-black">относительно рынка:</span>
            </p>
            <p class="text-2xl text-green">{{ estimatedPrice }} Р</p>
            <p class="text-xl">
              Наши сотрудники обязательно свяжутся с вами с результатами
              предварительной оценки.
            </p>
          </div>
        </div>
        <loader v-if="fetching.loadAppraisal" />
        <div v-show="showResult">
          <p class="mt-8 mb-4">
            Вы можете связаться с нами, написав на почту или оставить свои
            контактные данные.
          </p>
          <div class="grid grid-cols sm:grid-cols-3 gap-y-4 gap-x-4">
            <a
              href="https://t.me/Pragmatikabot"
              rel="nofollow"
              target="_blank"
              class="button button_green button_big"
              >Написать в Telegram</a
            >
            <a
              href="https://wa.me/79650073433?text=%D0%94%D0%BE%D0%B1%D1%80%D1%8B%D0%B9%20%D0%B4%D0%B5%D0%BD%D1%8C%2C%20%D0%BE%D0%B1%D1%80%D0%B0%D1%89%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%20pragmaticar.ru"
              rel="nofollow"
              target="_blank"
              class="button button_green button_big"
              >Написать в WhatApp</a
            >
            <a :href="mailtoHref" class="button button_green button_big"
              >Написать на почту</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
